/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { createContext, useState, useEffect } from 'react';
import axios from "axios";
import Api from "../Components/API/Api";

const CurrentUserContext = createContext();

export const CurrentUserContextProvider = ({ children }) => {
    const [singlePlayer, setSinglePlayer] = useState([])
    const [slideTeam, setSlideteam] = useState([])
    const [filteredPlayers, setFilteredPlayers] = useState([])
    const [loading, setLoading] = useState(false)
    const [select, setselect] = useState()
    const [teamSearchValue, setTeamSearchValue] = useState("")
    const [goalkeeper, setGoalkeeper] = useState([])
    const [defender, setDefender] = useState([])
    const [midfielder, setMidfielder] = useState([])
    const [forward, setForward] = useState([])
    const [playerSelectState, setPlayerSelectState] = useState([])
    const [displaymessage, setDisplaymessage] = useState(false)
    const [displayMessageDontAdd, setDisplayMessageDontAdd] = useState(false)


    useEffect(() => {
        getPlayer()
        getTeams()
    }, [])

    useEffect(() => {
        allStorage()
    }, [singlePlayer])

    const getPlayer = () => {
        setLoading(true)
        Api().then((response) => {
            setSinglePlayer(response.data.results)
            setFilteredPlayers(response.data.results)
        })
        setLoading(false)
    }

    const getTeams = () => {
        setLoading(true)
        axios.get('https://www.thesportsdb.com/api/v1/json/2/search_all_teams.php?l=English%20Premier%20League')
            .then((response) => { setSlideteam(response.data.teams) })
        setLoading(false)

    }

    //add team bagde

    slideTeam.map(team => {
        singlePlayer.filter(playerteam => {
            checkTeam(team, playerteam)
        })
    })

    function checkTeam(team, playerteam) {
        if (playerteam.player[0].strTeam === team.strTeam) { return Object.assign(playerteam.player[0], { "strTeamBadge": team.strTeamBadge }) }
    }


    //add Color
    let teamsColor = [{ "Arsenal": '#c1121f' }, { "Chelsea": '#1a659e' }, { "Liverpool": '#ad2831' }, { "Man United": '#DA291C' }, { "Tottenham": '#184773' }, { "Man City": '#6CABDD' }, { "Aston Villa": '#6E2237' }, { "Brentford": '#D90429' }, { "Brighton": '#219EBC' }, { "Burnley": '#81204C' }, { "Crystal Palace": '#1B458F' }, { "Everton": '#274488' }, { "Leeds": '#FDCB00' }, { "Leicester": '#0053A0' }, { "Newcastle": '#BBBDBF' }, { "Norwich": '#00A650' }, { "Southampton": '#FFC20E' }, { "Watford": '#000000' }, { "West Ham": '#7C2C3B' }, { "Wolves": '#FDB913' }]

    teamsColor.map(tColor => {
        singlePlayer.filter(playerteam => {
            checkColor(tColor, playerteam)
        })
    })

    function checkColor(tColor, playerteam) {
        if (playerteam.player[0].strTeam == Object.keys(tColor)) {
            return Object.assign(playerteam.player[0], { "strTeamColor": Object.values(tColor).toString() })
        }
    }


    const [show, setShow] = useState(false);

    if (loading) return "LOADING..."


    let values = []

    function allStorage() {
        let keys = Object.keys(localStorage),
            i = keys.length;

        while (i--) {
            values.push(keys[i]);
        }
        getNewPlayer(values)
    }


    function getNewPlayer(values) {
        let goalkeeperTemp = []
        let defenderTemp = []
        let midfielderTemp = []
        let forwardTemp = []


        singlePlayer.map(
            el => (
                values.map(valId => {

                    if ((el.player[0].idPlayer === valId) && (el.player[0].strPosition === "Goalkeeper")) {
                        goalkeeperTemp.push(el.player[0])
                    }
                    if ((el.player[0].idPlayer === valId) && (el.player[0].strPosition === "Right Back" || el.player[0].strPosition === "Full-back" || el.player[0].strPosition === "Centre Back" || el.player[0].strPosition === "Left Back" || el.player[0].strPosition === "Defender")) {
                        defenderTemp.push(el.player[0])
                    }
                    if ((el.player[0].idPlayer === valId) && (el.player[0].strPosition === "Midfielder" || el.player[0].strPosition === "Attacking Midfielder" || el.player[0].strPosition === "Centre Midfielder")) {
                        midfielderTemp.push(el.player[0])
                    }
                    if ((el.player[0].idPlayer === valId) && (el.player[0].strPosition === "Forward" || el.player[0].strPosition === "Winger" || el.player[0].strPosition === "Left Wing" || el.player[0].strPosition === "Right Wing")) {
                        forwardTemp.push(el.player[0])
                    }
                    setDefender([...defenderTemp])
                    setGoalkeeper([...goalkeeperTemp])
                    setMidfielder([...midfielderTemp])
                    setForward([...forwardTemp])
                }
                )
            )

        )



    }


    return (
        <CurrentUserContext.Provider
            value={{
                show,
                setShow,
                singlePlayer,
                setSinglePlayer,
                slideTeam,
                setSlideteam,
                filteredPlayers,
                setFilteredPlayers,
                select,
                setselect,
                teamSearchValue,
                setTeamSearchValue,
                goalkeeper,
                setGoalkeeper,
                defender,
                setDefender,
                midfielder,
                setMidfielder,
                forward,
                setForward,
                playerSelectState,
                setPlayerSelectState,
                displaymessage,
                setDisplaymessage,
                displayMessageDontAdd,
                setDisplayMessageDontAdd
            }}
        >
            {children}
        </CurrentUserContext.Provider>
    );

};

export default CurrentUserContext;